import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";
import { noop } from "utils/General";
import { actions, getters } from "../model";
import { DarkTab, Div } from "components/Base";
import { TABS } from "../constants";
import UnsavedChangesModal from "../../UnsavedChangesModal";
import { getFormHasChanges } from "../selectors";

const decorate = connect(
  state => ({
    tabs: TABS,
    selectedTab: getters.selectedTab(state),
    isEditingDetails: getters.isEditingDetails(state),
    formHasChanges: getFormHasChanges(state)
  }),
  bindInstance({
    onSelectTab: actions.setSelectedTab,
    onCancelUnsavedChanges: actions.onCancelUnsavedChanges,
    onConfirmUnsavedChanges: actions.onConfirmUnsavedChanges
  })
);

const Tabs = ({
  tabs,
  selectedTab = noop,
  onSelectTab = noop,
  isEditingDetails = false,
  onCancelUnsavedChanges,
  onConfirmUnsavedChanges,
  formHasChanges,
  ...styleProps
}) => {
  const selectedTabRef = useRef(null);
  const [showSaveChangesModal, setShowSaveChangesModal] = useState(false);
  const onTabClick = tabId => {
    if (isEditingDetails && formHasChanges) {
      setShowSaveChangesModal(true);
      selectedTabRef.current = tabId;
    } else {
      onSelectTab(tabId);
      onCancelUnsavedChanges();
    }
  };
  const hideSaveChangesModal = () => {
    setShowSaveChangesModal(false);
  };
  const proceedWithoutSaving = () => {
    onSelectTab(selectedTabRef.current);
    onConfirmUnsavedChanges();
    setShowSaveChangesModal(false);
  };

  return (
    <>
      {showSaveChangesModal && (
        <UnsavedChangesModal
          hideSaveChangesModal={hideSaveChangesModal}
          proceedWithoutSaving={proceedWithoutSaving}
        />
      )}
      <Div
        display="row.flex-start.flex-end"
        bc="gray3"
        px={5}
        pt={3}
        bb={1}
        style={{
          flexShrink: 0,
          width: "100%"
        }}
        {...styleProps}
      >
        {tabs.map(t => (
          <DarkTab
            fs={3}
            key={t.id}
            active={t.id === selectedTab}
            onClick={t.id === selectedTab ? noop : () => onTabClick(t.id)}
            className={[
              "accentable-tab",
              t.id === selectedTab ? "active-tab" : ""
            ].join(" ")}
          >
            {t.title}
          </DarkTab>
        ))}
      </Div>
    </>
  );
};

export default decorate(Tabs);
